import ElementPagination from "./src/index.vue";

ElementPagination.install = function(Vue) {
  Vue.component(ElementPagination.name, ElementPagination);
};

export default ElementPagination;
